/**
 * The right-click (or press-and-hold) menu: every action on the thing you pointed at, then
 * Examine, then Cancel. Tapping outside, pressing Escape or picking an option closes it.
 */
export interface MenuOption { label: string; sub?: string; act: () => void; tone?: 'attack' | 'muted' }

let open: HTMLElement | null = null;
export const menuOpen = () => !!open;
export function closeMenu() { open?.remove(); open = null; }

export function showMenu(x: number, y: number, title: string, options: MenuOption[]) {
  closeMenu();
  const el = document.createElement('div');
  el.className = 'ctxmenu plate'; el.setAttribute('role', 'menu');
  const h = document.createElement('div'); h.className = 'cm-title'; h.textContent = title; el.appendChild(h);
  for (const o of [...options, { label: 'Cancel', act: () => {}, tone: 'muted' as const }]) {
    const b = document.createElement('button'); b.type = 'button'; b.setAttribute('role', 'menuitem');
    b.className = `cm-opt${o.tone ? ` ${o.tone}` : ''}`;
    const l = document.createElement('span'); l.textContent = o.label; b.appendChild(l);
    if (o.sub) { const s = document.createElement('small'); s.textContent = o.sub; b.appendChild(s); }
    b.addEventListener('click', e => { e.stopPropagation(); closeMenu(); o.act(); });
    el.appendChild(b);
  }
  document.body.appendChild(el);
  // keep it on screen
  const r = el.getBoundingClientRect(), W = window.innerWidth, H = window.innerHeight;
  el.style.left = `${Math.max(6, Math.min(W - r.width - 6, x - r.width / 2))}px`;
  el.style.top = `${Math.max(6, Math.min(H - r.height - 6, y - 14))}px`;
  open = el;
  (el.querySelector('.cm-opt') as HTMLButtonElement | null)?.focus({ preventScroll: true });
}

document.addEventListener('pointerdown', e => { if (open && !open.contains(e.target as Node)) { closeMenu(); e.stopPropagation(); } }, true);
document.addEventListener('keydown', e => { if (open && e.key === 'Escape') { e.preventDefault(); closeMenu(); } });
